import { useEffect, useState } from 'react';
import { NotificationPreferencesContext } from './NotificationPreferencesContext';
import { getUserAttributes } from '../../api/UserAttributes';
import { getUser } from '../../selectors';
import { useSelector } from 'react-redux';
import Raven from 'raven-js';
import { isUserSettingsUpdatedMessage } from '../../utils/Messages';
import { jsx as _jsx } from "react/jsx-runtime";
export const NotificationPreferencesProvider = ({
  children
}) => {
  const {
    user_id
  } = useSelector(getUser);
  const [value, setValue] = useState({
    playTeaseSound: false,
    soundId: 0
  });
  useEffect(() => {
    let isMounted = true;
    let closeChannel;
    getUserAttributes().then(response => {
      if (response && response.userId === user_id && isMounted) {
        setValue({
          playTeaseSound: response.playTeaseSound,
          soundId: response.soundId
        });
      }
    }).catch(e => {
      Raven.captureException(e);
    });
    if ('BroadcastChannel' in window) {
      const channel = new BroadcastChannel('notifications-events');
      const handleMessage = e => {
        if (isUserSettingsUpdatedMessage(e)) {
          setValue({
            playTeaseSound: e.data.playTeaseSound,
            soundId: e.data.soundId
          });
        }
      };
      channel.addEventListener('message', handleMessage);
      closeChannel = () => {
        channel.removeEventListener('message', handleMessage);
        channel.close();
      };
    }
    return () => {
      var _closeChannel;
      isMounted = false;
      (_closeChannel = closeChannel) === null || _closeChannel === void 0 || _closeChannel();
    };
  }, [user_id]);
  return /*#__PURE__*/_jsx(NotificationPreferencesContext.Provider, {
    value: value,
    children: children
  });
};